export default "__VITE_ASSET__BBlZ0sws__"